import React from 'react';
import { Grid2 as Grid, Typography, Paper, Divider, Button, Tooltip, IconButton } from '@mui/material';
import { AddCircleOutlined, OpenInNew } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Announcements, Booking, ViewServiceRequestData, Violation, VisitorParkingRequest } from '../../Types/UnitFeatureTypes';
import DisplayAnnouncementCard from '../DisplayCards/DisplayAnnouncementCard';
import DisplayServiceRequestCard from '../DisplayCards/DisplayServiceRequestCard';
import DisplayBookingCard from '../DisplayCards/DisplayBookingCard';
import DisplayViolationCard from '../DisplayCards/DisplayViolationCard';
import DisplayVisitorParkingCard from '../DisplayCards/DisplayVisitorParkingCard';

const UnitDashboardSection: React.FC<{ title: string, data: Array<Announcements | VisitorParkingRequest | ViewServiceRequestData | Booking | Violation>, hasMore: boolean }> = ({ title, data, hasMore }) => {

    const navigate = useNavigate();
    const addButtonClicked = (title: string) => {
        if (title === 'Visitor Parking') {
            navigate('/requestVisitorParking');
        } else if (title === 'Service Requests') {
            navigate('/createServiceRequest');
        } else if (title === 'Bookings') {
            navigate('/createBooking');
        }
    };

    const handleViewMore = () => {
        if (title === 'Visitor Parking') {
            navigate('/visitorParkings');
        } else if (title === 'Service Requests') {
            navigate('/serviceRequests');
        } else if (title === 'Bookings') {
            navigate('/bookings');
        } else if (title === 'Reported Violations') {
            navigate('/violations');
        } else if (title === 'Announcements') {
            navigate('/announcements');
        }
    }

  return (
    <Paper sx={{ overflow: 'scroll', padding: 2, marginBottom: 3, background: '#f4f4f4', borderRadius: 3 }}>
        <Grid container spacing={2} justifyContent={'space-between'}>
            <Grid>
            <Typography variant="h4" sx={{ marginBottom: 2 }}>
                <b>{title}</b>
            </Typography>
            </Grid>
            {title !== 'Reported Violations' && title !== 'Announcements' && <Grid>
                <Tooltip title={`Add ${title}`}>
                    <IconButton
                        color="primary"
                        aria-label="add"
                        sx={{ padding: 1 }}
                        onClick={() => addButtonClicked(title)}
                    >
                        <AddCircleOutlined fontSize="large"/>
                    </IconButton>
                </Tooltip>
            </Grid>}
        </Grid>
      <Divider sx={{ marginY: 3, background: 'black'}} />
      {title === 'Announcements' && <DisplayAnnouncementCard item={data as Announcements[]} />}
      <Grid container spacing={2} overflow={'hidden'}>
        {data?.map(item => (
            <Grid key={item.id}>
                {title === 'Service Requests' && <DisplayServiceRequestCard item={item as ViewServiceRequestData} />}
                {title === 'Bookings' && <DisplayBookingCard item={item as Booking} />}
                {title === 'Reported Violations' && <DisplayViolationCard item={item as Violation} />}
                {title === 'Visitor Parking' && <DisplayVisitorParkingCard item={item as VisitorParkingRequest} />}
            </Grid>
        ))}
        {data.length === 0 && (
            <Grid>
                <Typography variant="h5" color="textSecondary">No {title} Available</Typography>
            </Grid>
        )}
        {hasMore && (
            <Grid size={{xs: 12}}>
                <Button variant="contained" color="primary" fullWidth onClick={handleViewMore}>
                    View More <OpenInNew sx={{ml: 3}} />
                </Button>
            </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default UnitDashboardSection;